import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const Login = resolve => require(['@/components/LoginNew'], resolve)
const changePassword = resolve => require(['@/components/ChangePassword'], resolve)
const Policy = resolve => require(['@/components/Policy'], resolve)

const Terms = resolve => require(['@/components/Terms'], resolve)
const Dashboard = resolve => require(['@/components/Dashboard'], resolve)

import Home from '@/components/Home'

const About = resolve => require(['@/components/Portal/About'], resolve)

const Download = resolve => require(['@/components/Portal/Download'], resolve)
const Contact = resolve => require(['@/components/Portal/Contact'], resolve)

const LoanSignup = resolve => require(['@/components/RegistrationLoan/Signup'], resolve)
const LoginProfile = resolve => require(['@/components/RegistrationLoan/LoginEditProfile'], resolve)
const ViewPresonalDetails = resolve => require(['@/components/RegistrationLoan/ViewPresonalDetailsProfile'], resolve)
const ViewGroupDetails = resolve => require(['@/components/RegistrationLoan/ViewGroupDetailsProfile'], resolve)
const ViewEducationDetails = resolve => require(['@/components/RegistrationLoan/viewPresDetailDashEducation'], resolve)
const ViewPersonalprofile = resolve => require(['@/components/RegistrationLoan/viewPresDetailDash'], resolve)
// import BankDetails from "@/components/RegistrationLoan/BankDetailsFormInvGroup";
const BankDetails = resolve => require(['@/components/RegistrationLoan/BankDetailsForm'], resolve)
const Eprofile = resolve => require(['@/components/RegistrationLoan/EditProfile'], resolve)
const LoanLOIPrint = resolve => require(['@/components/RegistrationLoan/LoanLOIPrint'], resolve)

const AdminDashboard = resolve => require(['@/components/Admin/AdminDashboard'], resolve)
const Applications = resolve => require(['@/components/Admin/Applications'], resolve)
const ProfileApproval = resolve => require(['@/components/Admin/ViewPersonalDetailsProfile'], resolve)
const GroupProfileApproval = resolve => require(['@/components/Admin/ViewGroupDetailsProfile'], resolve)
const ResetPassword = resolve => require(['@/components/Admin/ChangePassword'], resolve)
const Reports = resolve => require(['@/components/Admin/misReport'], resolve)
const ChangeBoard = resolve => require(['@/components/Admin/ChangeBoard'], resolve)

const AdminReports = resolve => require(['@/components/AdminReports/Report'], resolve)
const MasterReport = resolve => require(['@/components/AdminReports/MasterReport'], resolve)

const Disbursal = resolve => require(['@/components/LoanDisbursal/DisbursalList'], resolve)
const AddDisbursal = resolve => require(['@/components/LoanDisbursal/UploadDisbursal'], resolve)
const SanctionLetter = resolve => require(['@/components/LoanDisbursal/SanctionLetter'], resolve)

const ClaimUpload = resolve => require(['@/components/ClaimUpload/UploadClaim'], resolve)
const ClaimList = resolve => require(['@/components/ClaimUpload/ClaimList'], resolve)
const ClaimListAdmin = resolve => require(['@/components/ClaimUpload/ClaimListAdmin'], resolve)

const ClaimApproveList = resolve => require(['@/components/ClaimApproval/ClaimList'], resolve)
const SanctionLetterList = resolve => require(['@/components/ClaimApproval/SanctionLetterList'], resolve)
const DisbursalList = resolve => require(['@/components/ClaimApproval/DisbursalList'], resolve)

const VerifyLOI = resolve => require(['@/components/RegistrationLoan/VerifyLoi'], resolve)

const DocEdit = resolve => require(['@/components/Admin/DocumentUpload'], resolve)

const NotFound = resolve => require(['@/components/NotFound'], resolve)

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next()
    return
  }
  next('/home')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next()
    return
  }
  next('/')
}

const ifAuthenticatedProfile= (to, from, next) => {
  console.log(store.getters.isLoggedIn);
  if((!store.getters.lockProfile && store.getters.isLoggedIn) || !store.getters.isLoggedIn) {
    next()
    return
  } else {
    alert("Profile is Locked");
    next('/dashboard');
  }
}

const ifAdminAuthenticated = (to, from, next) => {
  var nme = store.getters.loggedUser;
  var RoleID =  nme.RoleID;
  if (store.getters.isLoggedIn && RoleID!=0) {
    next()
    return
  }
  next('/')
}


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/verifyloi/:ApplicationID/:LOINumber',
      name:'VerifyLOI',
      component:VerifyLOI,
      props:true
    },
    {
      path:'/claimupload',
      name: 'ClaimUpload',
      component:ClaimUpload,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/claims',
      name: 'ClaimList',
      component:ClaimList,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/claimsAdmin',
      name: 'ClaimListAdmin',
      component:ClaimListAdmin,
      props:true
    },
    {
      path:'/disbursals',
      name: 'DisbursalList',
      component:DisbursalList,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/approveclaims',
      name: 'ClaimApproveList',
      component:ClaimApproveList,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/sanctionletters',
      name: 'SanctionLetterList',
      component:SanctionLetterList,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/profileapproval',
      name: 'ProfileApproval',
      component:ProfileApproval,
      props:true,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/groupprofileapproval',
      name: 'GroupProfileApproval',
      component:GroupProfileApproval,
      props:true,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path:'/disbursal',
      name: 'Disbursal',
      component:Disbursal,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/newdisbursal',
      name: 'AddDisbursal',
      component: AddDisbursal,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/sanctionletter',
      name: 'SanctionLetter',
      component: SanctionLetter,
      beforeEnter:ifAuthenticated
    },
    {
      path:'/',
      name: 'Home',
      component:Home,

    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path:'/changePassword',
      name:'changePassword',
      component:changePassword,
      beforeEnter: ifAuthenticated,
    },
    {
      path:'/resetPassword',
      name:'resetPassword',
      component:ResetPassword,
      beforeEnter: ifAdminAuthenticated,
    },
    {
      path:'/reports',
      name:'reports',
      component:Reports,
      beforeEnter: ifAdminAuthenticated,
    },
    {
      path:'/changeboard',
      name:'ChangeBoard',
      component:ChangeBoard,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path: '/ViewPersonalprofile',
      name: 'ViewPersonalprofile',
      component: ViewPersonalprofile,
      beforeEnter: ifAuthenticated
    },
    {
      path:'/Eprofile',
      name:'Eprofile',
      component:Eprofile,
      beforeEnter: ifAuthenticatedProfile
    },

    // {
    //   path: '/aboutus',
    //   name: 'AboutUs',
    //   component: AboutUs
    // },
    {
      path: '/privacy',
      name: 'Policy',
      component: Policy
    },
    {
      path: '/BankDetails',
      name: 'BankDetails',
      component: BankDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/LoanLOIPrint',
      name: 'LoanLOIPrint',
      component: LoanLOIPrint,
      props: route => ({
        ApplicationID: route.params.ApplicationID || route.query.ApplicationID,
        Loantype: route.params.Loantype || route.query.Loantype,
        UserID: route.params.UserID || route.query.UserID,
        PastLOI: route.params.PastLOI || route.query.PastLOI
      }),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/DocEdit',
      name: 'DocEdit',
      component:DocEdit,
      props:true,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },

    {
      path: '/about',
      name: 'About',
      component: About
    },

    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },

    {
      path: '/ViewPresonalDetails',
      name: 'ViewPresonalDetails',
      component: ViewPresonalDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/ViewGroupDetails',
      name: 'ViewGroupDetails',
      component: ViewGroupDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/ViewEducationDetails',
      name: 'ViewEducationDetails',
      component: ViewEducationDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: ifAuthenticated,
    },

    {
      path: '/LoanSignup',
      name: 'LoanSignup',
      component: LoanSignup
    },
    {
      path: '/LoginProfile',
      name: 'LoginProfile',
      component: LoginProfile,
      beforeEnter: ifAuthenticatedProfile
    },

    {
      path: "/admindashboard",
      name: 'AdminDashboard',
      component: AdminDashboard,
      beforeEnter: ifAdminAuthenticated
    },
    {
      path: "/applications",
      name: 'Applications',
      component: Applications,
      props:true,
      beforeEnter: ifAdminAuthenticated
    },
    {
      path: "/adminreports",
      name: "AdminReports",
      component:AdminReports,
      beforeEnter:ifAdminAuthenticated
    },
    {
      path: "/masterreport",
      name: "MasterReport",
      component:MasterReport,
      beforeEnter:ifAdminAuthenticated
    },
    {
      // Catch all 404s
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: { hideHeader: true }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js